import { EventType, IncrementalSource, } from "@adora-so/types";
import { BucketedRateLimiter } from "./bucket-rate-limiter";
export class MutationThrottler {
    _rrweb;
    _options;
    _loggedTracker = {};
    _rateLimiter;
    constructor(_rrweb, _options = {}) {
        this._rrweb = _rrweb;
        this._options = _options;
        this._rateLimiter = new BucketedRateLimiter({
            bucketSize: this._options.bucketSize ?? 100,
            refillRate: this._options.refillRate ?? 10,
            refillInterval: 1000,
            _onBucketRateLimited: this._onNodeRateLimited,
        });
    }
    _onNodeRateLimited = (key) => {
        if (!this._loggedTracker[key]) {
            this._loggedTracker[key] = true;
            const node = this._getNode(key);
            this._options.onBlockedNode?.(key, node);
        }
    };
    _getNodeOrRelevantParent = (id) => {
        const node = this._getNode(id);
        if (node?.nodeName !== "svg" && node instanceof Element) {
            const closestSVG = node.closest("svg");
            if (closestSVG) {
                return [this._rrweb.mirror.getId(closestSVG), closestSVG];
            }
        }
        return [id, node];
    };
    _getNode = (id) => this._rrweb.mirror.getNode(id);
    _numberOfChanges = (data) => {
        return ((data.removes?.length ?? 0) +
            (data.attributes?.length ?? 0) +
            (data.texts?.length ?? 0) +
            (data.adds?.length ?? 0));
    };
    throttleMutations = (event) => {
        if (event.type !== EventType.IncrementalSnapshot ||
            event.data.source !== IncrementalSource.Mutation) {
            return event;
        }
        const data = event.data;
        const initialMutationCount = this._numberOfChanges(data);
        if (data.attributes) {
            data.attributes = data.attributes.filter((attr) => {
                const [nodeId] = this._getNodeOrRelevantParent(attr.id);
                const isRateLimited = this._rateLimiter.consumeRateLimit(nodeId);
                if (isRateLimited) {
                    return false;
                }
                return attr;
            });
        }
        const mutationCount = this._numberOfChanges(data);
        if (mutationCount === 0 && initialMutationCount !== mutationCount) {
            return;
        }
        return event;
    };
    reset() {
        this._loggedTracker = {};
    }
    stop() {
        this._rateLimiter.stop();
        this.reset();
    }
}
